import type { OrderStatus, SeasonPaymentState, SeasonStatus, SquadStatus } from '@otryad/shared';

import type { BadgeTone } from '@/components/ui';

export function seasonTone(status: SeasonStatus): BadgeTone {
  switch (status) {
    case 'SALE':
      return 'accent';
    case 'ACTIVE':
      return 'success';
    case 'CANCELLED':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function squadTone(status: SquadStatus): BadgeTone {
  switch (status) {
    case 'SALE':
      return 'accent';
    case 'ACTIVE':
      return 'success';
    case 'PAUSED':
      return 'warning';
    case 'DISBANDED':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function paymentTone(state: SeasonPaymentState): BadgeTone {
  switch (state) {
    case 'PAID':
      return 'success';
    case 'PENDING':
      return 'warning';
    case 'REFUNDED':
      return 'neutral';
    default:
      return 'danger';
  }
}

export function orderTone(status: OrderStatus): BadgeTone {
  switch (status) {
    case 'PAID':
      return 'success';
    case 'PENDING':
      return 'warning';
    case 'PARTIALLY_REFUNDED':
      return 'accent';
    case 'REFUNDED':
    case 'CANCELLED':
      return 'neutral';
    default:
      return 'danger';
  }
}
